// extracted by mini-css-extract-plugin
export var columnList = "_e4-0";